import Select from "react-select";

function CustomSelect(props) {

    let {
        options,
        handleChange = () => { },
        isMulti = false,
        value = '',
        labelKey,
        valKey,
        isSearchable = true,
        isClearaAble = true,
        label = "",
        errorMsg = "",
        isRequired = false
    } = props;

    options = options?.map((i) => ({
        label: i[labelKey],
        value: i[valKey]
    }))


    return (
        <div>
            <label htmlFor="" className="labelForASsign">
                {label}
            </label>
            <Select
                className=""
                options={options}
                isSearchable={isSearchable}
                isClearable={isClearaAble}
                required={isRequired}
                value={isMulti ? options.filter((item) =>
                    value.includes(item.value)
                ) : options.find(item => item.value === value) || null
                }

                styles={{
                    valueContainer: (base) => ({
                        ...base,
                        flexWrap: "nowrap",        // single line
                        overflowX: "auto",         // horizontal scroll
                    }),
                    multiValue: (base) => ({
                        ...base,
                        maxWidth: "100%",
                    }),
                    multiValueLabel: (base) => ({
                        ...base,
                        whiteSpace: "nowrap",      // single line
                        overflow: "visible",       // show full text
                        textOverflow: "unset",     // remove "..."
                    }),
                }}
                isMulti={isMulti}
                onChange={(e) => {
                    if (isMulti) {
                        let arr =
                            e &&
                            e.map((item) => {
                                return item.value;
                            });

                        handleChange(arr, e)
                    } else {
                        handleChange(e?.value, e)
                    }

                }}
            />
            <div style={{ color: "#dc3545", fontSize: "0.875em" }}>
                {errorMsg}
            </div>
        </div>
    )
}

export default CustomSelect